export default __webpack_public_path__ + "static/media/18.9f587434.webp";